import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, Star, Shield, Gift } from 'lucide-react';
export function Pricing() {
  return <Section background="teal" id="pricing" className="relative overflow-hidden" data-id="element-129">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-full max-w-4xl opacity-5 pointer-events-none" data-id="element-130">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#F5C842] rounded-full blur-3xl" data-id="element-131"></div>
        <div className="absolute bottom-20 right-10 w-64 h-64 bg-[#E8845F] rounded-full blur-3xl" data-id="element-132"></div>
      </div>

      <div className="max-w-lg mx-auto relative z-10" data-id="element-133">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-white" data-id="element-134">
          <div className="bg-[#E8845F] p-6 text-center text-white" data-id="element-135">
            <h2 className="text-2xl font-bold mb-2" data-id="element-136">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="opacity-90 text-sm" data-id="element-137">
              Todo lo que necesitas para mañanas en paz
            </p>
          </div>

          <div className="p-8" data-id="element-138">
            <div className="flex justify-center items-baseline mb-8" data-id="element-139">
              <span className="text-5xl font-bold text-gray-900" data-id="element-140">$6.39</span>
              <span className="text-xl text-gray-500 ml-2" data-id="element-141">USD</span>
            </div>

            <div className="space-y-4 mb-8" data-id="element-142">
              <div className="flex items-center p-3 bg-gray-50 rounded-lg" data-id="element-143">
                <div className="bg-[#4AAAA5] p-1 rounded-full mr-3" data-id="element-144">
                  <Check className="w-3 h-3 text-white" data-id="element-145" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-146">
                  Kit Principal de Rutinas (PDF)
                </span>
              </div>

              <div className="space-y-3 pl-2" data-id="element-147">
                <div className="flex items-center text-sm text-gray-600" data-id="element-148">
                  <Gift className="w-4 h-4 text-[#F5C842] mr-2" data-id="element-149" />
                  <span data-id="element-150">
                    <strong className="text-[#E8845F]" data-id="element-151">Bono 1:</strong> Mini
                    guía de frases efectivas
                  </span>
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-152">
                  <Gift className="w-4 h-4 text-[#F5C842] mr-2" data-id="element-153" />
                  <span data-id="element-154">
                    <strong className="text-[#E8845F]" data-id="element-155">Bono 2:</strong> Plan de
                    implementación 14 días
                  </span>
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-156">
                  <Gift className="w-4 h-4 text-[#F5C842] mr-2" data-id="element-157" />
                  <span data-id="element-158">
                    <strong className="text-[#E8845F]" data-id="element-159">Bono 3:</strong> Tablero
                    de puntos (2 estilos)
                  </span>
                </div>
              </div>
            </div>

            <Button className="w-full text-lg shadow-xl" size="lg" withIcon href="https://www.mundomamis.com/cart/43938138390637:1" data-id="element-160">
              Descargar Ahora
            </Button>

            <p className="text-center text-xs text-gray-400 mt-4" data-id="element-161">
              Pago seguro • Entrega digital inmediata al correo
            </p>
          </div>
        </div>

        <div className="mt-12 text-center space-y-6" data-id="element-162">
          <h3 className="text-2xl font-bold text-gray-900" data-id="element-163">
            No necesitas una casa perfecta.
            <br data-id="element-164" />
            Necesitas una mañana que no te rompa.
          </h3>
          <p className="text-gray-600" data-id="element-165">
            Dale a tu hijo un mapa. Y recupérate a ti misma/o en el proceso.
          </p>
          <div className="flex justify-center items-center space-x-2 text-sm text-gray-500" data-id="element-166">
            <Shield className="w-4 h-4" data-id="element-167" />
            <span data-id="element-168">Garantía de satisfacción de 30 días</span>
          </div>
        </div>
      </div>
    </Section>;
}